import React from "react";
import { NodeSizeButton } from "./../_shared/node-size-button/node-size-button.js";
import { getNodeInSelection } from "./../_shared/resolvers/get-node-in-selection.js";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./../editor-common/index.js";
import { handleAudioUpload } from ".//handle-audio-upload.js";
import {
  FLOATING_PLUGIN_TOOLBAR,
  NodeAlignmentButton
} from "./../toolbars-v3/index.js";
import { AUDIO_BUTTONS, AUDIO_REPLACE_MODAL_ID, AUDIO_SETTINGS_MODAL_ID } from "./consts.js";
import { PLUGIN_TOOLBAR_AUDIO_SETTINGS_BUTTON } from "./data-hooks.js";
import { InsertModal } from "./modals/InsertModal.js";
import { AudioSettingsModal } from "./modals/SettingsModal.js";
const isCustomAudioResolver = {
  id: "isCustomAudio",
  resolve: (content) => {
    if (Array.isArray(content) && content.length > 0) {
      return !!content[content.length - 1].attrs?.audio?.src?.id;
    } else {
      return false;
    }
  }
};
const getToolbarButtons = (config, services) => {
  const { modals } = services;
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS_WITH_LABEL,
      dataHook: PLUGIN_TOOLBAR_AUDIO_SETTINGS_BUTTON,
      attributes: {
        visible: isCustomAudioResolver,
        selectedNode: getNodeInSelection
      },
      command: ({ isMobile, referenceElement, attributes: { selectedNode }, publicCommands }) => {
        const { uploadService, updateService } = services;
        modals?.togglePluginPanel({
          id: AUDIO_SETTINGS_MODAL_ID,
          Component: AudioSettingsModal,
          componentProps: {
            nodeId: selectedNode.attrs.id,
            onFileSelect: () => {
              if (uploadService && updateService) {
                handleAudioUpload({
                  services,
                  publicCommands,
                  nodeId: selectedNode.attrs.id,
                  type: "image"
                });
              }
            }
          },
          isMobile,
          positioning: {
            referenceElement: referenceElement?.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
            placement: "right-start"
          },
          focusReturnElement: referenceElement
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: isCustomAudioResolver,
        selectedNode: getNodeInSelection
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(
        NodeSizeButton,
        {
          id: AUDIO_BUTTONS.size,
          toolbarItem,
          options: ["SMALL", "CONTENT"]
        }
      )
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: AUDIO_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      attributes: {
        active: {
          resolve: (_, { modals: modals2 }) => Boolean(modals2.getModal(AUDIO_REPLACE_MODAL_ID))
        }
      },
      command: ({ isMobile, referenceElement, attributes: { selectedNode } }) => {
        const {
          audio: { src },
          id
        } = selectedNode.attrs;
        modals?.togglePluginPanel({
          id: AUDIO_REPLACE_MODAL_ID,
          Component: InsertModal,
          componentProps: {
            componentData: selectedNode.attrs,
            nodeId: id,
            embedType: src.url,
            modalId: AUDIO_REPLACE_MODAL_ID
          },
          isMobile,
          positioning: {
            referenceElement,
            placement: "bottom"
          },
          mobileLayout: "drawer"
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
